(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmd-client-stories"] && !Shopify.designMode) return;
  try {
    
function connectLmdReviews() {
  document.querySelectorAll('[data-lmd-reviews]').forEach(root => {
    if (root.dataset.connected) return;
    root.dataset.connected = 'true';
    const source = root.querySelector('.lmd-review-source');
    const update = () => {
      const rating = source.querySelector('.jdgm-all-reviews-rating');
      const count = source.querySelector('[data-number-of-reviews]');
      const review = source.querySelector('[data-review-id="760870ed-2f88-43ee-b686-a42bd3f2cfde"]') || source.querySelector('.jdgm-carousel-item');
      const body = review?.querySelector('.jdgm-carousel-item__review-body');
      const author = review?.querySelector('.jdgm-carousel-item__reviewer-name');
      const time = review?.querySelector('.jdgm-carousel-item__timestamp');
      const score = Number(rating?.dataset.score);
      const total = Number(count?.dataset.numberOfReviews);
      if (!rating || !body || !author || !time || !score || !total) return;
      const stars = rating.cloneNode(true);
      stars.removeAttribute('tabindex');
      root.querySelector('.lmd-review-stars').replaceChildren(stars);
      root.querySelector('.lmd-review-summary').textContent = score.toLocaleString('fr-FR', {maximumFractionDigits:2}) + '/5 · ' + total.toLocaleString('fr-FR') + ' avis';
      root.querySelector('.lmd-review-quote').textContent = '« ' + body.textContent.trim() + ' »';
      const parts = (time.dataset.time || '').split('/');
      const date = parts.length === 3 ? new Date(Number(parts[2]), Number(parts[0])-1, Number(parts[1])).toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'}) : time.textContent.trim();
      root.querySelector('.lmd-review-author').textContent = author.textContent.trim() + ' · ' + date;
      root.querySelector('.lmd-review-display').hidden = false;
      root.setAttribute('data-ready','');
    };
    new MutationObserver(update).observe(source,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-score','data-number-of-reviews']});
    update();
    root.querySelector('.lmd-editorial-link').addEventListener('click', () => { root.querySelector('.lmd-all-reviews').open = true; });
  });
}
connectLmdReviews();
document.addEventListener('shopify:section:load',connectLmdReviews);

  } catch(e) { console.error(e); }
})();
})();
